import { Flex, List, Space, Typography } from 'antd';
import { RoundContainer } from 'shared/ui';
import classes from './ListItem.module.css';
import { RightOutlined } from '@ant-design/icons';


type ListItemProps = {
  title: string;
  icon: React.ReactNode;
  subtext?: string;
  onSelect: () => unknown;
};

const ListItem: React.FC<ListItemProps> = ({ title, icon, subtext, onSelect }) => {
  return (
    <List.Item className={classes.item} onClick={onSelect}>
      <Flex align='center' justify='space-between' className='w100'>
        <Space size={14}>
          <RoundContainer padding={20} size={22} color='#0000000A'>{icon}</RoundContainer>
          <Flex vertical>
            <Typography.Text className={classes.text}>{title}</Typography.Text>
            {subtext && <Typography.Text className={classes.subtext}>{subtext}</Typography.Text>}
          </Flex>
        </Space>
        <RightOutlined />
      </Flex>
    </List.Item>
  );
};

export default ListItem;